// extracted by mini-css-extract-plugin
export default {"board":"ScoreBoard_board__PitGc","score_board":"ScoreBoard_score_board__xTzFU"};